export enum BasicInfoFields {
  HierarchyType = 'hierarchyType',
  TopPartnerId = 'topPartnerId',
  ParentPartnerId = 'parentPartnerId',
  CommunicationName = 'communicationName',
  Email = 'email',
  TaxId = 'taxId',
  Url = 'url',
  Phone = 'phone',
  PhoneCountryCode = 'phoneCountryCode',
  StoreNumber = 'storeNumber',
  AddressLine1 = 'addressLine1',
  AddressLine2 = 'addressLine2',
  AddressLine3 = 'addressLine3',
  Country = 'country',
  State = 'state',
  City = 'city',
  ZipCode = 'zipCode',
  WorkflowStatus = 'workflowStatus',
}

export enum LegalInfoFields {
  CompanyEnglishName = 'companyEnglishName',
  CompanyLegalName = 'companyLegalName',
  CompanyLegalNameNonLatin = 'companyLegalNameNonLatin',
  LegalAddressLine1 = 'legalAddressLine1',
  LegalAddressLine2 = 'legalAddressLine2',
  LegalAddressLine3 = 'legalAddressLine3',
  LegalCountry = 'legalCountry',
  LegalState = 'legalState',
  LegalCity = 'legalCity',
  LegalZipCode = 'legalZipCode',
  LegalWorkflowStatus = 'legalWorkflowStatus',
}

export enum AdditionalInfoFields {
  FacebookLink = 'facebookLink',
  LinkedInLink = 'linkedInLink',
  TwitterLink = 'twitterLink',
  WhatsAppLink = 'whatsAppLink',
  HasNotOnlineCommerce = 'hasNotOnlineCommerce',
  ECommerceLinks = 'ecommerceLinks',
  SocialMediaLinks = 'socialMediaLinks',
}

export enum SettingFields {
  DoCopyBasicAddress = 'doCopyBasicAddress',
  DoCopyBasicName = 'doCopyBasicName',
}
